import { render, staticRenderFns } from "./UploadedByCell.vue?vue&type=template&id=55703658&scoped=true&"
import script from "./UploadedByCell.vue?vue&type=script&lang=js&"
export * from "./UploadedByCell.vue?vue&type=script&lang=js&"
import style0 from "./UploadedByCell.vue?vue&type=style&index=0&id=55703658&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55703658",
  null
  
)

export default component.exports